module.exports = __webpack_public_path__ + "static/Shujinko-a199aeaece4991635c13f1665bdf492b.jpg";